// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xT_q","option":"styles_option__snzZe","selected":"styles_selected__2tgud"};